import React from "react";
import Button from "../Reusable/Button";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const ConfirmDialog = (props) => {
  const { setIsOpen, handleDelete } = props;
  return (
    <div className={tw`flex flex-col justify-center items-center w-[300px]`}>
      <p>Are you sure you want to delete?</p>
      <div className={tw`w-full flex justify-center gap-x-6 items-center `}>
        <div className={tw`w-24`}>
          <Button
            type={"button"}
            label={"Yes"}
            onClick={() => handleDelete()}
          />
        </div>

        <button
          type="button"
          className={tw`w-24 text-white py-2 rounded my-2 bg-gray-500`}
          onClick={() => setIsOpen(false)}
        >
          NO
        </button>
      </div>
    </div>
  );
};

export default ConfirmDialog;
